export default __webpack_public_path__ + "static/media/Shadowed Valleys-9.c3798d7f.jpg";